"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CBX_JUNE_2_LAUNCH = exports.CBX_COVIDRESPONSE_GROWTH_SUITE_DISCOUNT = exports.CBX_COVIDRESPONSE_REMOTE_SALES_TOOLS = exports.CBX_CONTACT_SALES_PAGE = exports.CMS_MARCH_2020_RELEASE = void 0;
var CMS_MARCH_2020_RELEASE = 'CMS_MARCH_2020_RELEASE';
exports.CMS_MARCH_2020_RELEASE = CMS_MARCH_2020_RELEASE;
var CBX_CONTACT_SALES_PAGE = 'CBX_CONTACT_SALES_PAGE';
exports.CBX_CONTACT_SALES_PAGE = CBX_CONTACT_SALES_PAGE;
var CBX_COVIDRESPONSE_REMOTE_SALES_TOOLS = 'CBX_COVIDRESPONSE_REMOTE_SALES_TOOLS';
exports.CBX_COVIDRESPONSE_REMOTE_SALES_TOOLS = CBX_COVIDRESPONSE_REMOTE_SALES_TOOLS;
var CBX_COVIDRESPONSE_GROWTH_SUITE_DISCOUNT = 'CBX_COVIDRESPONSE_GROWTH_SUITE_DISCOUNT';
exports.CBX_COVIDRESPONSE_GROWTH_SUITE_DISCOUNT = CBX_COVIDRESPONSE_GROWTH_SUITE_DISCOUNT;
var CBX_JUNE_2_LAUNCH = 'CBX_MARKETING_CONTACTS_JUNE_2_LAUNCH';
exports.CBX_JUNE_2_LAUNCH = CBX_JUNE_2_LAUNCH;


//////////////////
// WEBPACK FOOTER
// ./js/constants/PublicFeatureFlags.js
// module id = 287
// module chunks = 5 6 7